'use strict';

/* eslint-disable no-undef */
const Analytics = require('./analytics');

function getListType (container) {
    var list = '';
    if (container.closest('.container.search-results').length > 0) {
        let categorySearchID = container.closest('.container.search-results').data('category-search-id');
        if (categorySearchID === '') {
            list = 'search';
        } else {
            list = 'listing';
        }
    }
    if (container.parents('.carousel-einstein-recently-viewed').length > 0) {
        list = 'recently_viewed';
    } else if (container.parents('.completeYourLookContainer').length > 0) {
        list = 'complete_your_look';
    } else if (container.parents('.wishlistItemCards').length > 0) {
        list = 'wishlist';
    } else if (container.parents('.cart-line-item').length > 0) {
        list = 'cart';
    } else if (container.parents('.slider-prodotti-container').length > 0) {
        list = 'you_may_like_also';
    } else if (container.parents('.suggestedProductsContainer').length > 0) {
        list = 'suggested_products';
    }

    if (container.parents('.js-page-home-gender').length > 0) {
        list = 'home';
    }

    // If list is sorted, keep this type
    let localStorageListType = localStorage.getItem('listtype');
    if (localStorageListType === 'product_name_ascending' || localStorageListType === 'product_name_descending') {
        list = localStorageListType;
    }

    return list;
}
class CartInteraction extends Analytics {
    getProductFromRaw (rawProduct) {
        let productBaseInfo = this.helper.getProductBaseInfo(rawProduct);
        let productGender = this.helper.getProductGender(rawProduct);
        let productVariant = 'color' in productBaseInfo ? productBaseInfo.color : '';
        let promo = productBaseInfo.promo;
        let addAnother = $('.js-add-another-to-cart').length > 0;
        let addedFromComplete = $('.js-productCards-complete-promo').length > 0;
        let isCartPage = $('.page[data-action="Cart-Show"]').length > 0;
        let isPlpPage = $('.page[data-action="Search-Show"]').length > 0;
        if (rawProduct.price && rawProduct.price.discountValue) {
            promo = (promo && promo !== 'no_promotion') ? promo + ',sale' : 'sale';
        }
        if (addAnother || (isPlpPage && addedFromComplete) || (isCartPage && addedFromComplete)) {
            rawProduct.GTMItemListName = 'complete_the_promo';
            if (isCartPage) {
                rawProduct.GTMItemListId = 'cart';
            } else if (addAnother || (isPlpPage && addedFromComplete)) {
                rawProduct.GTMItemListId = 'minicart';
            }
        }
        let product = {
            item_id: 'id' in productBaseInfo ? productBaseInfo.id : 'id' in rawProduct ? rawProduct.id.split('_')[0].trim() : '',
            item_name: this.helper.formatString(rawProduct.nameEng),
            price: rawProduct.price.sales.value.toFixed(2),
            quantity: '',
            index: rawProduct.GTMIndex,
            item_brand: 'intimissimi',
            item_category: rawProduct.categoryPath,
            item_category2: productGender,
            item_category3: rawProduct.secondLevelCategory,
            item_category4: rawProduct.thirdLevelCategory,
            item_category5: rawProduct.fourthLevelCategory,
            item_list_name: rawProduct.GTMItemListName,
            item_list_id: rawProduct.GTMItemListId,
            item_variant: productVariant,
            size: productBaseInfo.size,
            item_on_sale: rawProduct.price.list ? 'Yes' : 'No',
            item_availability: rawProduct.available ? 'Available' : 'No',
            coupon: promo || 'no_promotion',
            item_color: rawProduct.colorFamilyEng ? rawProduct.colorFamilyEng.toLowerCase() : '',
            item_sfcc: rawProduct.id,
            item_customization: rawProduct.uniqueIdentifier ? 'customized' : 'no',
            discount: rawProduct.price.list ? (rawProduct.price.list.value - rawProduct.price.sales.value).toFixed(2) : 0.00,
            item_sustainable: rawProduct.isGreen ? 'sustainable_item' : 'classic_item'
        };
        product.item_id = product.item_id ? product.item_id.replace('~', '/') : '';
        return this.helper.formatProductForAnalytics(product);
    }

    cartInteractionProductList (basket) {
        let products = [];
        if (basket.items.length > 0) {
            for (let i = 0; i < basket.items.length; i++) {
                let item = basket.items[i];
                var product = {
                    'mc_id': item.id.split(' ')[0],
                    'mc_price': item.price.sales.value.toFixed(2),
                    'mc_quantity': item.quantity,
                    'mc_item_sfcc': item.id.replace('~', '/')
                };
                products.push(product);
            }
        }
        return products;
    }

    getGiftcardFromRaw (rawProduct) {
        let productBaseInfo = this.helper.getProductBaseInfo(rawProduct);
        let productGender = this.helper.getProductGender(rawProduct);

        let product = {
            id: 'id' in productBaseInfo ? productBaseInfo.id : 'id' in rawProduct ? rawProduct.id.split('_')[0].trim() : '',
            name: 'electronic_giftcard',
            price: rawProduct.priceTotal.priceValue.toFixed(2),
            quantity: rawProduct.quantity,
            item_brand: 'intimissimi',
            item_category: 'giftcard',
            item_category2: productGender || 'not_available',
            item_category3: rawProduct.secondLevelCategory || 'not_available',
            item_category4: rawProduct.thirdLevelCategory || 'not_available',
            item_category5: rawProduct.fourthLevelCategory || 'not_available',
            item_variant: '',
            size: '',
            item_on_sale: rawProduct.price.list ? 'Yes' : 'No',
            item_availability: rawProduct.available ? 'Available' : 'No',
            coupon: 'promo' in productBaseInfo && productBaseInfo.promo ? productBaseInfo.promo : 'no_promotion',
            item_color: '',
            item_sfcc: rawProduct.id,
            item_customization: rawProduct.uniqueIdentifier ? 'customized' : 'no',
            discount: rawProduct.price.list ? (rawProduct.price.list.value - rawProduct.price.sales.value).toFixed(2) : 0.00
        };
        return this.helper.formatProductForAnalytics(product);
    }

    cartInteractionProduct (rawProduct) {
        // let productBaseInfo = this.helper.getProductBaseInfo(rawProduct);
        // let productGender = this.helper.getProductGender(rawProduct);

        let product = rawProduct;
        /* {
                   id: rawProduct.id,
                   name: this.helper.formatString(rawProduct.name),
                   price: rawProduct.price.toFixed(2),
                   quantity: '',
                   brand: rawProduct.brand,
                   category: rawProduct.category,
                   variant: rawProduct.variant,
                   dimension102: productBaseInfo.size,
                   dimension103: rawProduct.productType2,
                   dimension104: rawProduct.price.list ? 'Yes' : 'No',
                   dimension105: rawProduct.available ? 'Disponibile' : 'No',
                   dimension109: productBaseInfo.promo,
                   dimension113: rawProduct.colorFamilyEng,
                   item_sfcc: rawProduct.id,
                   dimension115: productGender,
                   metric111: rawProduct.price.list ? (rawProduct.price.list.value - rawProduct.price.sales.value).toFixed(2) : ''
               };
               */
        // product.price = product.price.toFixed(2);
        // product.metric111 = product.metric111.toFixed(2);
        return this.helper.formatProductForAnalytics(product);
    }

    getAddType ($container, itemCustomization) {
        if ($container.hasClass('product-quickview')) {
            if ($container.find('.update-cart-product-global').length > 0) {
                return 'change_on_cart';
            } else if ($container.hasClass('analytics-completeYourPromo')) {
                return 'promo';
            } else {
                return 'quick_view';
            }
        } else if ($container.hasClass('analytics-addToCart-sticky')) {
            return 'product_sticky';
        } else if ($container.hasClass('product-save-for-later')) {
            return 'saved_for_later';
        } else if ($container.hasClass('product-info')) {
            return 'add_another';
        } else if (itemCustomization === 'customized') {
            return 'customization';
        } else if ($container.hasClass('wishlist-product-card')) {
            return 'wishlist';
        } else if ($container.hasClass('product-detail')) {
            return 'product';
        }
        return 'quick_view';
    }

    getRemoveType () {
        return 'cart';
    }

    init (globalContainer, helperContainer) {
        this.logName = 'CartInteraction';
        super.init(globalContainer, helperContainer);

        this.oldCart = null;
        this.toRemoveQuantity = null;

        this.prepareObservers();
        this.setListPathObservers();
    }

    pushAddToCartInteraction (data, $container) {
        let rawProduct = null;
        if ($container === 'bonus_product') {
            rawProduct = data.bonusProduct;
        } else {
            let itemsInCart;
            let newProductId;
            if (!data.cart && data.cartModel) {
                itemsInCart = data.cartModel.items;
                newProductId = data.form.uuid;
            } else {
                itemsInCart = data.cart.items;
                newProductId = data.pliUUID;
            }
            rawProduct = itemsInCart.filter(function (item) {
                return item.UUID === newProductId;
            })[0];
            if (rawProduct.item_list_name === 'complete_your_look') {
                localStorage.setItem('listtypeforcart', localStorage.getItem('prevlisttypeforcart'));
            }
        }

        let product = this.getProductFromRaw(rawProduct);
        product.quantity = parseInt(data.form.quantity);

        if (product.item_list_name === 'cart' && $container !== 'bonus_product' && this.helper.checkPage('cart')) {
            let editedProductId = localStorage.getItem('clickedProductEdit');
            if (data.newProductId && editedProductId && editedProductId === data.newProductId.replace(/ /g, '_').toLowerCase()) {
                // update item from cart. only quantity changed
                product.quantity = data.form.quantity - 1;
            } else if (data.form.quantity) {
                product.quantity = data.form.quantity;
            } else {
                product.quantity = 1;
            }

            let itemColor = $('[data-item_sfcc="' + data.newProductId + '"').data('item_color');
            product.item_color = (itemColor && itemColor.toLowerCase()) || product.item_color;
        }
        if (product.quantity < 1) {
            return;
        }

        this.log('Pushing Add to Cart impression for: ' + product.id, true);

        let type;
        if ($container === 'bonus_product') {
            type = 'quickview';
            product.discount = product.price;
            product.price = '0.00';
            product.item_on_sale = 'yes';
            let bonusPromotion = localStorage.getItem('bonusProductPromotion');
            if (product.coupon === 'no_promotion' && bonusPromotion) {
                product.coupon = bonusPromotion;
            }
        } else {
            let itemCustomization = product.item_customization ? product.item_customization : '';
            type = this.getAddType($container, itemCustomization);
        }

        let pushObject = {
            'event': 'add_to_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'add_type': type,
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': product.item_list_name === 'not_available' ? 'listing' : product.item_list_name,
                'item_list_id': product.item_list_id === 'not_available' ? 'pdp' : product.item_list_id,
                'items': [ product ]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushAddAllToCartWishlistInteraction (data) {
        let _self = this;
        var products = [];
        for (i in data.allAddToCartItems) {
            delete data.allAddToCartItems[i].item_list_name;
            delete data.allAddToCartItems[i].index;
            data.allAddToCartItems[i].quantity = 1;
            products.push(_self.helper.formatProductForAnalytics(data.allAddToCartItems[i]));
        }

        let pushObject = {
            'event': 'add_to_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'add_type': 'wishlist',
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': 'wishlist',
                'item_list_id': this.helper.getListId(),
                'items': [ products ]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushAddToCartGiftCardInteraction (data) {
        let rawProduct = null;
        rawProduct = data.cart.items.filter(function (item) {
            return item.UUID === data.pliUUID;
        })[0];

        let product = this.getGiftcardFromRaw(rawProduct);

        this.log('Pushing Add to Cart impression for giftCard');

        let pushObject = {
            'event': 'add_to_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'add_type': 'product',
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': rawProduct.item_list_name,
                'item_list_id': rawProduct.item_list_id,
                'items': [ product ]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushCartGiftWrapInteraction (data) {
        let currency = $('.analytics.helperData').data('currency');

        let items = data.order.items.items.map((rawItem, index) => {
            let item = this.getProductFromRaw(rawItem);
            item.quantity = rawItem.quantity;
            item.index = index;
            return item;
        });

        let pushObject = {
            'event': 'add_to_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'add_type': 'product',
            'ecommerce': {
                'currency': currency,
                'item_list_name': data.listName,
                'item_list_id': 'checkout',
                'items': items
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushGiftKitInteraction (data) {
        let currency = $('.analytics.helperData').data('currency');
        let items = data.order.items.items
            .filter(rawItem => {
                return rawItem.GTMItemListName === 'gift_kit';
            })
            .map((rawItem, index) => {
                let item = this.getProductFromRaw(rawItem);
                item.quantity = rawItem.quantity;
                item.item_list_id = rawItem.GTMItemListId;
                item.item_list_name = rawItem.GTMItemListName;
                item.index = index;
                return item;
            });

        let pushObject = {
            'event': 'add_to_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'add_type': 'product',
            'ecommerce': {
                'currency': currency,
                'item_list_name': 'gift_kit',
                'item_list_id': 'checkout',
                'items': items
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    updateCartAbandoned (data) {
        let products = this.cartInteractionProductList(data);
        this.log('Pushing Update Abandoned Cart impression');

        let pushObject = {
            'event': 'MCupdateCart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'cart': {
                'products': products
            }
        };

        this.push(pushObject);
    }

    pushUserRemovedAllItems (location) {
        this.push({
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '50',
            'eventname': 'empty_cart',
            'position': location
        });
    }

    pushRemoveFromCartInteraction (data) {
        let product = this.cartInteractionProduct(data.product);
        product.quantity = this.toRemoveQuantity;

        this.log('Pushing Remove from Cart impression for: ' + product.id, true);

        const eventItemListValues = this.helper.findEventItemListValues(product);

        let pushObject = {
            'event': 'remove_from_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'remove_type': this.getRemoveType(),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': eventItemListValues.itemListName,
                'item_list_id': eventItemListValues.itemListId,
                'items': [product]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);

        this.toRemoveQuantity = null;
    }

    pushRemoveMultipleFromCartInteraction (data) {
        let products = [];
        let idString = null;

        data.products.forEach((product, index) => {
            let productFromRaw = this.getProductFromRaw(product);
            productFromRaw.quantity = product.quantity; // must be the real quantity for that product
            products.push(productFromRaw);
            idString = idString ? idString + ', ' + product.id : product.id;
        });

        this.log('Pushing Remove from Cart impression for: ' + idString, true);

        const eventItemListValues = this.helper.findEventItemListValues(products);

        let pushObject = {
            'event': 'remove_from_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'remove_type': this.getRemoveType(),
            'ecommerce': {
                'currency': this.helperData ? this.helperData.currency : $('.analytics.helperData').data().currency,
                'item_list_name': eventItemListValues.itemListName,
                'item_list_id': eventItemListValues.itemListId,
                'items': products
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushRemoveAllFromCartInteraction (data) {
        let products = this.cartInteractionProduct(data.analyticsProducts);

        this.log('Pushing Remove from Cart for all items ', true);

        const eventItemListValues = this.helper.findEventItemListValues(products);

        let pushObject = {
            'event': 'remove_from_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'remove_type': this.getRemoveType(),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': eventItemListValues.itemListName,
                'item_list_id': eventItemListValues.itemListId,
                'items': products
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushRemoveFromCartData (data) {
        let product = this.cartInteractionProduct(data.productData);
        product.quantity = 1;

        this.log('Pushing Remove from Cart impression for: ' + product.id, true);

        const eventItemListValues = this.helper.findEventItemListValues(product);

        let pushObject = {
            'event': 'remove_from_cart',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'remove_type': data.remove_type,
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': eventItemListValues.itemListName,
                'item_list_id': eventItemListValues.itemListId,
                'items': [product]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    retrieveProductInfoAndRemoveFromCart (pageData) {
        this.toRemoveQuantity = $('.product-info.uuid-' + pageData.params.uuid.trim() + ' .checkout-product').data().quantity;

        let div = pageData.outerDiv;
        let id = div.data('id');
        let color = div.data('variant');

        let _self = this;
        let sku = id + '_color_' + color;
        let url = this.helperData.varianturl.replace('PID_PLACEHOLDER', encodeURIComponent(sku));
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {
                pid: sku
            },
            success: function (data) {
                _self.pushRemoveFromCartInteraction(data);
            },
            error: function (err) {
                _self.log('Cannot retrieve product information' + err);
            }
        });
    }

    pushLoyaltyCoupon (couponCode, where) {
        this.push({
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '31',
            'eventname': 'coupon',
            'coupon': couponCode,
            'area': where
        });
    }

    prepareObservers () {
        var _self = this;

        $('body').on('product:didChangeSizeQuickAddToCart', function (e, data) {
            try {
                data.sku = _self.helper.getFormatSku(data.form.pid);
                data.size = data.sku.split('_')[2];
                if (data.$productContainer) {
                    data.promotionType = data.$productContainer.find('.analytics.productListingItem').data('coupon') === 'no_promotion' ? 'no_promo' : 'promo';
                } else {
                    data.promotionType = $('.container.product-detail.product-detail-keeper.product-wrapper').find('.analytics.productListingItem').data('coupon') === 'no_promotion' ? 'no_promo' : 'promo';
                }
                if (data.sku && data.promotionType) {
                    _self.quickImpressionSender.pushProductChangeSizeInteraction(data);
                }
            } catch (e) {
                console.log('Failed:', e);
            }
        });

        $('body').on('product:afterAddToCart', function (e, data) {
            try {
                if (data.$productContainer === undefined) {
                    _self.pushAddToCartInteraction(data, $('.container.product-detail.product-detail-keeper.product-wrapper'));
                } else {
                    if(data) {
                        _self.pushAddToCartInteraction(data, data.$productContainer);
                    }
                }
                if(data) {
                    _self.updateCartAbandoned(data.cart);
                }
            } catch (e) {
                console.log('Failed:', e);
            }
        });

        $('body').on('product:afterAddToCartGiftCard', function (e, data) {
            try {
                _self.pushAddToCartGiftCardInteraction(data);
            } catch (e) {}
        });

        $('body').on('product:pushCartGiftWrapInteraction', function (e, data) {
            _self.pushCartGiftWrapInteraction(data);
        });

        $('body').on('product:pushGiftKitInteraction', function (e, data) {
            _self.pushGiftKitInteraction(data);
        });

        $('body').on('removedAllItemsFromCart', function (e, { location }) {
            _self.pushUserRemovedAllItems(location);
            _self.pushRemoveAllFromCartInteraction({ analyticsProducts: _self.helper.getProductList() });
        });

        $('body').on('removeItemFromCartSuccessful', function (e, data) {
            // _self.retrieveProductInfoAndRemoveFromCart(data);
            _self.pushRemoveFromCartData(data); // retrieveProductInfoAndRemoveFromCart(data);
            _self.updateCartAbandoned(data.basket);
        });

        $('body').on('product:removeExternalItemSuccessfully', function (e, data) {
            _self.pushRemoveFromCartData(data);
        });

        $('body').on('cart:afterCouponApply', function (e, data) {
            let code = data.code.toUpperCase();
            let where = window.location.href.includes('cart') ? 'from_cart' : (window.location.href.includes('shipping') ? 'from_shipping_page' : 'from_payment_page');
            if (code !== '') {
                _self.quickImpressionSender.pushCartAppliedCouponCode(code, data.btnAction, where);
            }
        });

        $('body').on('loyaltyCoupon:apply', function (e, data) {
            let where = window.location.href.includes('cart') ? 'from_cart' : (window.location.href.includes('shipping') ? 'from_shipping_page' : 'from_payment_page');
            _self.pushLoyaltyCoupon(data.couponCode, where);
        });

        $('body').on('click', '.shipping-methods-recap, .check-dispo-availability', function (e, data) {
            _self.quickImpressionSender.pushShippingMethodsMoreInfo($(e.currentTarget).data('analytics-cta'));
        });

        $('body').on('product:addQuantityFromCart', function (e, data) {
            try {
                _self.pushAddToCartInteraction(data, data.$productContainer);
                _self.updateCartAbandoned(data.cartModel);
            } catch (e) {}
        });

        $('body').on('product:afterAddAllToCartWishlist', function (e, data) {
            try {
                _self.pushAddAllToCartWishlistInteraction(data);
            } catch (e) {}
        });

        $('body').on('product:afterAddFromSaveForLater', function (e, data) {
            if (data && data.$productContainer) {
                _self.pushAddToCartInteraction(data, data.$productContainer);
            }
        });

        $('body').on('click', '.js-cart-category-tabs-analytics', function (e) {
            _self.quickImpressionSender.pushCartTabsClick($(e.currentTarget).data('analytic-name'));
        });
    }

    /**
     * For analytics to save the add to cart path
     */
    setListPathObservers () {
        $('body')
            .on('click touchstart', '.image-container, #crossSellContainer .tile-body', function () {
                let listType = getListType($(this));
                try {
                    localStorage.setItem('prevlisttype', localStorage.getItem('listtype'));
                    localStorage.setItem('prevlisttypeforcart', localStorage.getItem('listtypeforcart'));
                    localStorage.setItem('listtype', listType);
                    localStorage.setItem('listtypeforcart', listType);
                } catch (e) { }
            })
            .on('click touchstart', '.suggestions .item--product a', function () {
                try {
                    localStorage.setItem('prevlisttype', localStorage.getItem('listtype'));
                    localStorage.setItem('prevlisttypeforcart', localStorage.getItem('listtypeforcart'));
                    localStorage.setItem('listtype', 'search');
                    localStorage.setItem('listtypeforcart', 'search');
                } catch (e) {}
            })
            .on('click touchstart', '.completeLook .add-to-cart-quick-add', function () {
                try {
                    localStorage.setItem('prevlisttype', localStorage.getItem('listtype'));
                    localStorage.setItem('prevlisttypeforcart', localStorage.getItem('listtypeforcart'));
                    localStorage.setItem('listtype', 'complete_the_look');
                    localStorage.setItem('listtypeforcart', 'complete_the_look');
                } catch (e) {}
            })
            .on('click touchstart', '.suggestedProductsContainer .js-pdp-link', function () {
                try {
                    localStorage.setItem('prevlisttype', localStorage.getItem('listtype'));
                    localStorage.setItem('prevlisttypeforcart', localStorage.getItem('listtypeforcart'));
                    localStorage.setItem('listtype', 'suggested_products');
                    localStorage.setItem('listtypeforcart', 'suggested_products');
                } catch (e) {}
            })
            .on('click touchstart', '.carousel-einstein-recently-viewed .js-pdp-link', function () {
                try {
                    localStorage.setItem('prevlisttype', localStorage.getItem('listtype'));
                    localStorage.setItem('prevlisttypeforcart', localStorage.getItem('listtypeforcart'));
                    localStorage.setItem('listtype', 'recently_viewed');
                    localStorage.setItem('listtypeforcart', 'recently_viewed');
                } catch (e) {}
            })
            .on('click touchstart', '.wishlist-product-card .js-add-to-cart', function () {
                try {
                    localStorage.setItem('prevlisttype', localStorage.getItem('listtype'));
                    localStorage.setItem('prevlisttypeforcart', localStorage.getItem('listtypeforcart'));
                    localStorage.setItem('listtype', 'wishlist');
                    localStorage.setItem('listtypeforcart', 'wishlist');
                } catch (e) {}
            })
            .on('click touchstart', '.cart-line-item', function () {
                try {
                    localStorage.setItem('prevlisttype', localStorage.getItem('listtype'));
                    localStorage.setItem('prevlisttypeforcart', localStorage.getItem('listtypeforcart'));
                    localStorage.setItem('listtype', 'cart');
                    localStorage.setItem('listtypeforcart', 'cart');
                } catch (e) {}
            })
            .on('click touchstart', '.buy-look-containerAnalytics .cross-sell-item', function () {
                try {
                    localStorage.setItem('prevlisttype', localStorage.getItem('listtype'));
                    localStorage.setItem('prevlisttypeforcart', localStorage.getItem('listtypeforcart'));
                    localStorage.setItem('listtype', 'shop_the_look');
                    localStorage.setItem('listtypeforcart', 'shop_the_look');
                } catch (e) {}
            })
            .on('click touchstart', '.cart-line-item .edit', function () {
                try {
                    localStorage.setItem('prevlisttype', localStorage.getItem('listtype'));
                    localStorage.setItem('prevlisttypeforcart', localStorage.getItem('listtypeforcart'));
                    localStorage.setItem('listtype', 'cart');
                    localStorage.setItem('listtypeforcart', 'cart');
                } catch (e) {}
            });
        /*
        .on('click touchstart', '.product-quickview .close-button', function () {
            try {
                localStorage.setItem('listtype', localStorage.getItem('prevlisttype'));
                localStorage.setItem('listtypeforcart', localStorage.getItem('prevlisttypeforcart'));
            } catch (e) { }
        });
        */
    }
}

const obj = new CartInteraction();
module.exports = obj;
